import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { AccountRoleVM } from "@shared-kernel/application/ports/shared/shared-repository";
import { retrieveAccountRoles } from "./retrieve-account-roles";

const initialState: RetrievalState<AccountRoleVM[]> = { fetching: "idle", data: [] };

export const retrieveAccountRolesReducer = createReducer<RetrievalState<AccountRoleVM[]>>(initialState, builder => {
  builder.addCase(retrieveAccountRoles.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveAccountRoles.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveAccountRoles.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
